import axiosClient from "axiosClient";
import axiosClientStilo from "axiosClient/indexStilo";
import { getQueryString } from "utilities/common";
import { HEMP,STILO } from "utilities/constants";
const adminsMode = JSON.parse(localStorage.getItem('adminsMode'))

export async function fetchMemberAPI() {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get('/api/v1/member');
}

export async function fetchMemberDetailsAPI(memberId) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/member/${memberId}`);
}

export function fetchAgeVerifyAPI(data) {
    return axiosClientStilo.post(`/api/v1/pos/age/verification`, data)
}
export async function addMemberAPI(data) {
    return await  (adminsMode === STILO ? axiosClientStilo : axiosClient).post(`/api/v1/member`, data);
}

export async function updateMemberAPI(data, memberId) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).put(`/api/v1/member/update/${memberId}`, data);
}

export async function deleteMemberAPI(memberId) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).delete(`/api/v1/member/${memberId}`);
}

export async function fetchMemberOrdersAPI(data, memberId) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/member/orders?memberId=${memberId}`, data);
}
export async function updateCardBlockAPI(data) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).put(`/api/v1/member/block/online/payments`, data);
}

export async function updateWalletMemberAPI(data) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).put(`/api/v1/member/adjust/wallet`, data);
}

export async function fetchWalletLogsAPI(data) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/member/wallet/logs?${getQueryString(data)}`);
}